import { render, staticRenderFns } from "./SubHeading.vue?vue&type=template&id=336cbd38&"
import script from "./SubHeading.vue?vue&type=script&lang=ts&"
export * from "./SubHeading.vue?vue&type=script&lang=ts&"
import style0 from "./SubHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports